import Spinner from './Spinner.jsx';

const VARIANTS = {
  primary: 'bg-accent text-white hover:bg-accent-hover',
  secondary: 'border border-border-strong hover:bg-bg-elevated',
  ghost: 'hover:bg-bg-elevated text-text-secondary',
  danger: 'bg-red-600 text-white hover:bg-red-500',
};

export default function Button({
  children, variant = 'primary', loading = false, disabled = false,
  className = '', type = 'button', onClick, ...rest
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`inline-flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium
        transition-colors disabled:opacity-50 disabled:cursor-not-allowed
        ${VARIANTS[variant] ?? VARIANTS.primary} ${className}`}
      {...rest}
    >
      {loading && <Spinner size={14} className={variant === 'primary' || variant === 'danger' ? 'text-white' : undefined} />}
      {children}
    </button>
  );
}
